import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownTextElementProps {
  markdown: string;
}

export const MarkdownTextElement: React.FC<MarkdownTextElementProps> = ({ markdown }) => {
  return (
    <div className="ds-markdown text-right">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </div>
  );
};
